import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Star } from "@/components/Product/Rating/star/star.component";
import { useWriteReviewContext } from "@/components/Product/Reviews/context/writeReview.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const WriteReviewComponent = ({ className }: Props) => {
    const { t } = useGranite();

    const { open } = useWriteReviewContext();

    const handleOnClick = () => {
        open();
    };

    return (
        <Button
            className={cn("tw:flex tw:items-center tw:gap-2", className)}
            outline={true}
            onClick={handleOnClick}
        >
            <Star
                value={0}
                size={20}
                className={cn(
                    "tw:overflow-visible tw:-translate-y-px",
                    "tw:[&>path]:stroke-2 tw:[&>path]:stroke-primary tw:[&>path]:transition-colors tw:[&>path]:fill-none",
                    "tw:group-hover/button:[&>path]:stroke-white"
                )}
            />
            {t("general.reviews.write")}
        </Button>
    );
};
